export function blobToFile(theBlob, fileName){
    return new File([theBlob], fileName, {lastModifiedDate: new Date()});
}